var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.751 6.657c1.507-1.507 3.875-3.033 7.25-3.033 3.374 0 5.742 1.526 7.248 3.033a11.953 11.953 0 0 1 1.648 2.064 10.129 10.129 0 0 1 .5.89c.01.025.02.044.027.058l.007.017.003.006v.002s.002.001-.684.306l.685.305-.001.003-.003.006-.008.017a6.76 6.76 0 0 1-.129.259c-.088.17-.22.406-.398.688a11.951 11.951 0 0 1-1.647 2.065c-1.506 1.506-3.874 3.031-7.249 3.031-3.374 0-5.742-1.525-7.249-3.031a11.952 11.952 0 0 1-1.647-2.065 10.12 10.12 0 0 1-.5-.89 4.593 4.593 0 0 1-.027-.057l-.008-.017-.003-.006v-.002s-.001-.001.684-.306a72.667 72.667 0 0 1-.685-.305l.001-.003.003-.006.008-.017a4.093 4.093 0 0 1 .128-.259c.09-.17.221-.406.399-.689A11.95 11.95 0 0 1 2.75 6.657zM1.251 10l-.686-.305a.752.752 0 0 0 0 .61L1.25 10zm.84 0c.07.128.164.291.282.48.31.49.784 1.147 1.439 1.802 1.306 1.306 3.313 2.592 6.188 2.592 2.876 0 4.883-1.286 6.189-2.592a10.45 10.45 0 0 0 1.438-1.803c.119-.188.212-.351.282-.479a10.451 10.451 0 0 0-1.72-2.282C14.883 6.41 12.876 5.123 10 5.123c-2.875 0-4.882 1.287-6.188 2.594A10.45 10.45 0 0 0 2.09 10zm16.66 0 .684.305a.752.752 0 0 0 0-.61L18.75 10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.625a2.375 2.375 0 1 0 0 4.75 2.375 2.375 0 0 0 0-4.75zM6.125 10a3.875 3.875 0 1 1 7.75 0 3.875 3.875 0 0 1-7.75 0z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/icon-show.2e83f7c7.svg";
export { ForwardRef as ReactComponent };